<template>
  <div class="about-us-container">
    <seg-main>
      <div v-html="content" />
    </seg-main>
  </div>
</template>

<script>
import SegMain from '@/components/segPart/segMain';

import {getPages} from '@/api';


export default {
  name: 'AboutUs',
  components: {
    SegMain
  },
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    this.getContent()
  },
  methods: {
    getContent() {
      getPages({
        name: '走进万豪-公司简介'
      }).then(res => {
        if(res.data.success) {
          this.content = res.data.data[0].content
        }
      })
    }
  }
};
</script>

<style scoped lang="less">

</style>
